import { callAPI } from "./api";

export const getCustomerInformation = async (selectedWO) => {
  const { CustomerId, StoreId, OdsCustomerId, Source } = selectedWO;
  const route = `customerInformation/${CustomerId}?odsCustomerId=${OdsCustomerId}&source=${Source}`;
  
  try {
    const data = await callAPI(route);
    return data;
  } catch (error) {
    throw error;
  }
};